import './header.scss'

const selectors = {
  header: '[data-header]',
  headerOverlay: '[data-header-overlay]',
  headerMobileMenuTrigger: '[data-header-trigger]',

  menu: '[data-header-menu]',
  submenu: '[data-header-submenu]',
  submenuTrigger: '[data-header-submenu-trigger]',
  submenuContent: '[data-header-submenu-content]',
  submenuTab: '[data-header-submenu-tab]',
  submenuTabHeader: '[data-header-submenu-tab-header]',
  submenuTabContent: '[data-header-submenu-tab-content]',
  submenuPane: '[data-header-submenu-pane]',

  search: '[data-search]',
  searchTrigger: '[data-search-trigger]',

  active: 'active',
}

const handleTabClick = (e, activeIndex, tabs, panes) => {
  if (!window.matchMedia('(max-width: 1279px)').matches) return
  if (e.target.closest(selectors.submenuTabContent)) return

  e.preventDefault()
  tabs.forEach((tab, index) => {
    const isActive = tab.classList.contains(selectors.active)
    const tabContent = tab.querySelector(selectors.submenuTabContent)

    tabContent.style.height = '0px'
    tab.classList.remove(selectors.active)

    if (activeIndex === index && !isActive) {
      tabContent.style.height = tabContent.firstElementChild.clientHeight + 'px'
      tab.classList.add(selectors.active)
    }
  })
}

const handleTabHover = (activeIndex, tabs, panes) => {
  if (!window.matchMedia('(min-width: 1280px)').matches) return

  panes.forEach((pane, index) => pane.classList[activeIndex === index ? 'add' : 'remove'](selectors.active))
  tabs.forEach((tab, index) => tab.classList[activeIndex === index ? 'add' : 'remove'](selectors.active))
}

const resetMenu = (submenu) => {
  submenu?.forEach((submenu) => {
    const tabs = submenu.querySelectorAll(selectors.submenuTab)

    submenu.classList.remove(selectors.active)
    tabs.forEach((tab) => {
      const tabContent = tab.querySelector(selectors.submenuTabContent)

      tabContent.style.height = '0px'
      tab.classList.remove(selectors.active)
    })
  })
}

const initMobileMenuTriggers = (header, submenu, triggers) =>
  triggers.forEach((trigger) =>
    trigger.addEventListener('click', () => {
      header.classList.toggle(selectors.active)

      resetMenu(submenu)
    })
  )

const initTabs = (submenu) => {
  submenu.tabs.forEach((tab, index) => {
    tab.addEventListener('mouseenter', () => handleTabHover(index, submenu.tabs, submenu.panes))
    tab.addEventListener('click', (e) => handleTabClick(e, index, submenu.tabs, submenu.panes))
  })

  if (window.matchMedia('(min-width: 1280px)').matches) handleTabHover(0, submenu.tabs, submenu.panes)
}

const handleClickOutside = (menuItems, header) => {
  header.classList.remove(selectors.active)
  menuItems.forEach((menuItem) => menuItem.submenu.classList.remove(selectors.active))
}

const handleMenuItemHover = (activeIndex, menuItems, header) =>
  menuItems.forEach((menuItem, index) => {
    if (window.matchMedia('(min-width: 1280px)').matches) {
      if (index === activeIndex) {
        header.classList.add(selectors.active)
        menuItem.submenu.classList.add(selectors.active)
      } else {
        menuItem.submenu.classList.remove(selectors.active)
      }
    }
  })

const handleMenuItemClick = (activeIndex, menuItems, header) => {
  menuItems.forEach((menuItem, index) => {
    const isActive = menuItem.submenu.classList.contains(selectors.active)

    if (window.matchMedia('(max-width: 1279px)').matches) {
      if (activeIndex === undefined || activeIndex !== index || (isActive && index === activeIndex)) {
        menuItem.submenu.classList.remove(selectors.active)
      } else {
        menuItem.submenu.classList.add(selectors.active)
      }
    }
  })
}

const initSubmenu = (submenu, header) => {
  const overlay = header.querySelector(selectors.headerOverlay)

  submenu = Array(...submenu).map((submenu) => {
    const triggers = submenu.querySelectorAll(selectors.submenuTrigger)
    const content = submenu.querySelector(selectors.submenuContent)
    const tabs = submenu.querySelectorAll(selectors.submenuTab)
    const panes = submenu.querySelectorAll(selectors.submenuPane)

    return {
      submenu,
      triggers,
      content,
      tabs,
      panes,
    }
  })

  overlay.addEventListener('click', () => handleClickOutside(submenu, header))

  submenu?.forEach((submenuItem, activeIndex) => {
    submenuItem.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => handleMenuItemClick(activeIndex, submenu, header))
      trigger.addEventListener('mouseenter', () => handleMenuItemHover(activeIndex, submenu, header))
    })

    initTabs(submenuItem)
  })
}

const initSearch = (searchContainers) => {
  const menu = document.querySelector(selectors.menu)

  searchContainers.forEach((container) => {
    const triggers = container.querySelectorAll(selectors.searchTrigger)

    triggers.forEach((trigger) =>
      trigger.addEventListener('click', () => {
        container.classList.toggle(selectors.active)

        if (container.classList.contains(selectors.active)) {
          menu.style.setProperty('--header-menu-position', 'relative')
        } else {
          menu.style.removeProperty('--header-menu-position')
        }
      })
    )
  })
}

const initHeader = (header) => {
  const mobileMenuTriggers = header.querySelectorAll(selectors.headerMobileMenuTrigger)
  const searchContainers = header.querySelectorAll(selectors.search)
  let submenu = header.querySelectorAll(selectors.submenu)

  if (submenu.length && mobileMenuTriggers.length) initMobileMenuTriggers(header, submenu, mobileMenuTriggers)
  if (submenu.length) initSubmenu(submenu, header)
  if (searchContainers.length) initSearch(searchContainers)
}

document.addEventListener('DOMContentLoaded', async function () {
  const header = document.querySelector(selectors.header)

  header && initHeader(header)
})
